import React from "react";
import Empty from "./empty";
import { useAuth } from "@/common/hooks/use_auth";

/**
 * 对于一些菜单, 有入口(resourceAuthList能找到), 没有数据权限, 这时候用这个组件包装一下:
 * @效果 模糊背景, 并显示暂无权限的提示; 无权限提示始终展示在menu对应的content中间位置
 */
const PagePermission = ({ children }) => {
  const [hasAuth, auth] = useAuth();

  if (hasAuth) {
    return children;
  }

  if (auth) {
    return (
      <div className="relative rounded-lg">
        <div className="blur">{children}</div>
        <div className="absolute left-0 top-0 z-[1000] h-full w-full rounded-lg bg-white/50 backdrop-blur">
          <Empty
            className="sticky top-0 h-full max-h-[calc(100vh-56px-48px-32px)]"
            image="https://commimg.pddpic.com/upload/dmp/no_permission.png.slim.png"
            title="暂无权限"
            content={auth?.noAuthMsg}
          />
        </div>
      </div>
    );
  }

  return null;
};

export default PagePermission;
